"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.callable = void 0;
/**
 * Pass in something that should be a function, and get a function back
 *
 * If you pass in a function, it will be returned
 *
 * If you pass in something falsey, then a new function will be returned.
 *
 * This ensures that whatever you wrap with this function will be a callable
 * result, and will not crash your program.
 *
 * @param callback The function to call
 */
function callable(callback) {
    return callback || (() => null);
}
exports.callable = callable;



//////////////////
// WEBPACK FOOTER
// ./src/client/components/ui/callable.ts
// module id = 75
// module chunks = 0 1 2